<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view') }} {{ $tc('signageurl', 1) }}</div>
      <div>
        <router-link
          class="btn-blue"
          to="signage-url"
        >{{ $tc('signageurl', 1) }} {{ $tc('list', 1) }}</router-link>
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('cinema',1) }}{{ $t('name')}}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="signageUrlDetails.cine_name" class="mr-3">{{signageUrlDetails.cine_name}}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('signage',1) }} URL</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span
              v-if="signageUrlDetails.su_signage_url"
              class="mr-3"
            >{{signageUrlDetails.su_signage_url}}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
            <button class="btn-blue" type="button" @click="doCopy">Copy URL</button>
          </div>

          <!-- <div v-clipboard:copy="signageUrlDetails.su_signage_url" @click.native="onError()">Copy!</div> -->
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('screen',1) }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span
              v-if="signageUrlDetails.screen_name"
              class="mr-3"
            >{{signageUrlDetails.screen_name}}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>

      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('signage',1) }} URL {{ $tc('active') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="signageUrlDetails.su_is_active" class="mr-3">{{$t('yes')}}</span>
            <span v-else class="mr-3">{{$t('no')}}</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>

      <div v-if="login_user_role_id === 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdat') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span
              v-if="signageUrlDetails.created_at"
              class="mr-3"
            >{{signageUrlDetails.created_at | dateparse}}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
      <div v-if="login_user_role_id === 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdby') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="signageUrlDetails.created_by" class="mr-3">{{signageUrlDetails.created_by}}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
      <div v-if="login_user_role_id === 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('updatedat')}}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span
              v-if="signageUrlDetails.updated_at"
              class="mr-3"
            >{{signageUrlDetails.updated_at | dateparse }}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
      <div v-if="login_user_role_id === 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('updatedby') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="signageUrlDetails.updated_by" class="mr-3">{{signageUrlDetails.updated_by}}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Vue from "vue";

import moment from "moment";
import signageServices from "@/services/signageService";
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      login_user_role_id: null,
      signageUrlDetails: []
    };
  },

  beforeMount() {
    // this.roleID = this.secureStore.get("USINFO").role_id;

    const { su_id } = this.$route.query;
    console.log("su_id :", su_id);

    if (su_id) {
      this.getSignageDetails(su_id);
    } else {
      this.$router.go(-1);
    }
    const { role_id } = this.secureStore.get("USINFO");
    this.login_user_role_id = role_id;
  },
  mounted() {},
  methods: {
    getSignageDetails: function(su_id) {
      signageServices.getSingleSignageUrlDetails({ su_id }).then(response => {
        const { data } = response;

        if (data.Records) {
          let obj = data.Records[0];
          this.signageUrlDetails = {
            ...this.signageUrlDetails,
            ...data.Records[0]
          };
          Object.keys(this.signageUrlDetails).map(x => {
            this.signageUrlDetails[x] = obj[x] || this.signageUrlDetails[x];
            if (x === "created_by") {
              this.getViewUsersDetails(
                obj[x],
                "created_by",
                "signageUrlDetails"
              );
            } else if (x === "updated_by") {
              this.getViewUsersDetails(
                obj[x],
                "updated_by",
                "signageUrlDetails"
              );
            }
          });

          // this.getBankList(this.cardDetails.bank_id || null);
        }
      });
    },
    getViewUsersDetails(user_id, fieldvalue, key) {
      this[key][fieldvalue] = "-";
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this[key][fieldvalue] = data.Records[0].user_name;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      }
    },
    doCopy: function() {
      this.$copyText(this.signageUrlDetails.su_signage_url).then(e => {
        if (e.action === "copy") {
          this.$toasted.show("URL Copied");
        } else {
          this.$toasted.show("URL Can not Copy");
        }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/SignageUrl/viewSignageUrl.vue